module.exports = __webpack_public_path__ + "static/media/avena_cereales.9ee3e605.png";